import { render, staticRenderFns } from "./data-files-stats.vue?vue&type=template&id=18f2d7f4"
import script from "./data-files-stats.vue?vue&type=script&lang=js"
export * from "./data-files-stats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports